import App from 'next/app'
import React from 'react'
import { Provider } from 'mobx-react'
import { WithStores } from '../stores'
import Router from 'next/router'
import { hidePageLoader, showPageLoader } from '../utils/page-loader'
import { initEnvConfig } from '../utils/init-env-config'

Router.events.on('routeChangeStart', showPageLoader)
Router.events.on('routeChangeComplete', hidePageLoader)
Router.events.on('routeChangeError', hidePageLoader)

class MyApp extends App {
  static async getInitialProps (appContext) {
    const appProps = await App.getInitialProps(appContext)
    const env = await initEnvConfig()

    return {
      ...appProps,
      env
    }
  }

  componentDidMount () {
    const cssVars = require('css-vars-ponyfill').default
    cssVars()
  }

  render () {
    const { Component, pageProps, stores, env } = this.props

    return (
      <Provider {...stores}>
        <Component {...pageProps} env={env} />
      </Provider>
    )
  }
}

export default WithStores(MyApp)
